import {
    GET_COURSE,
    COURSE_LOADING,
    GET_COURSES,
    COURSES_LOADING,
    GET_COURSES_CATEGORIES,
    GET_COURSES_LEVELS,
    GET_COURSES_TYPES,
    TAXONOMIES_LOADING,
    SET_COURSES_SEARCH_CRITERIA,
    RESET_COURSES_SEARCH_CRITERIA,
    GET_OTHER_COURSES_CATEGORY,
    OTHER_COURSES_CATEGORY_LOADING,
    SIGNUP_TO_COURSE,
    SIGNOUT_FROM_COURSE,
    SIGNUPOROUT_TO_COURSE_LOADING,
    SIGNUPOROUT_TO_COURSE_FAILURE,
    DASHBOARD_GET_COURSES_CHECKEDIN,
    DASHBOARD_GET_COURSES_AUTHOR,
    DASHBOARD_GET_COURSES_LOADING,
} from './types';

const initialState = {
    course: null,
    courseLoading: false,
    courseSignupOrOut: false,
    courseSignupOrOutLoading: false,
    courseSignupOrOutError: {},

    courses: [],
    coursesLoading: false,

    dashboardCoursesCheckedin: [],
    dashboardCoursesAuthor: [],
    dashboardCoursesLoading: false,

    otherCoursesCategory: [],
    otherCoursesCategoryLoading: false,

    categories: [],
    levels: [],
    types: [],
    taxonomiesLoading: false,

    hasMore: false,
    currentPage: 1,
    newSearch: false, // Set to TRUE to reinitialize the search results (= fresh/new list)
    fakeLoadingTime: 0,
    search: {
        submitted: false,
        category: '',
        level: '',
        type: '',
        english: false,
        suggestions: false,
    },
};

export default function (state = initialState, action) {
    switch (action.type) {
        case COURSE_LOADING:
            return {
                ...state,
                courseLoading: true
            };
        case COURSES_LOADING:
            return {
                ...state,
                coursesLoading: true
            };
        case DASHBOARD_GET_COURSES_LOADING:
            return {
                ...state,
                dashboardCoursesLoading: true
            };
        case TAXONOMIES_LOADING:
            return {
                ...state,
                taxonomiesLoading: true
            };
        case OTHER_COURSES_CATEGORY_LOADING:
            return {
                ...state,
                otherCoursesCategoryLoading: true
            };
        case GET_COURSES:
            const courses = (action.newSearch) ? action.payload.posts : [...state.courses, ...action.payload.posts];

            return {
                ...state,
                courses: courses,
                coursesLoading: false,
                hasMore: action.payload.hasMore,
                currentPage: action.page,
                search: {
                    ...action.search,
                    submitted: false,
                },
                fakeLoadingTime: action.fakeLoadingTime,
            };
        case DASHBOARD_GET_COURSES_CHECKEDIN:
            const coursesCheckedin = (action.newSearch) ? action.payload.posts : [...state.dashboardCoursesCheckedin, ...action.payload.posts];

            return {
                ...state,
                dashboardCoursesCheckedin: coursesCheckedin,
                dashboardCoursesLoading: false,
                hasMore: action.payload.hasMore,
                currentPage: action.page,
                fakeLoadingTime: action.fakeLoadingTime,
            };
        case DASHBOARD_GET_COURSES_AUTHOR:
            const coursesAuthor = (action.newSearch) ? action.payload.posts : [...state.dashboardCoursesAuthor, ...action.payload.posts];

            return {
                ...state,
                dashboardCoursesAuthor: coursesAuthor,
                dashboardCoursesLoading: false,
                hasMore: action.payload.hasMore,
                currentPage: action.page,
                fakeLoadingTime: action.fakeLoadingTime,
            };
        case GET_COURSE:
            return {
                ...state,
                course: action.payload,
                courseLoading: false
            };
        case GET_COURSES_CATEGORIES:
            return {
                ...state,
                categories: action.payload,
                taxonomiesLoading: false
            };
        case GET_COURSES_LEVELS:
            return {
                ...state,
                levels: action.payload,
                taxonomiesLoading: false
            };
        case GET_COURSES_TYPES:
            return {
                ...state,
                types: action.payload,
                taxonomiesLoading: false
            };
        case SET_COURSES_SEARCH_CRITERIA:
            return {
                ...state,
                search: {
                    submitted: true,
                    category: action.searchTaxonomyCategory,
                    level: action.searchTaxonomyLevel,
                    type: action.searchTaxonomyType,
                    english: action.searchEnglish,
                    suggestions: action.searchSuggestions,
                },
            };
        case RESET_COURSES_SEARCH_CRITERIA:
            return {
                ...state,
                search: {
                    submitted: false,
                    category: action.searchTaxonomyCategory,
                    level: action.searchTaxonomyLevel,
                    type: action.searchTaxonomyLevel,
                    english: action.searchEnglish,
                    suggestions: action.searchSuggestions,
                },
            };
        case GET_OTHER_COURSES_CATEGORY:
            return {
                ...state,
                otherCoursesCategory: action.payload,
                otherCoursesCategoryLoading: false
            };
        case SIGNUP_TO_COURSE:
            return {
                ...state,
                courseSignupOrOutLoading: false,
                courseSignupOrOut: true,
            };
        case SIGNOUT_FROM_COURSE:
            return {
                ...state,
                courseSignupOrOutLoading: false,
                courseSignupOrOut: true,
            };
        case SIGNUPOROUT_TO_COURSE_LOADING:
            return {
                ...state,
                courseSignupOrOutLoading: true,
                courseSignupOrOutError: {},
                courseSignupOrOut: false,
            };
        case SIGNUPOROUT_TO_COURSE_FAILURE:
            return {
                ...state,
                courseSignupOrOutLoading: false,
                courseSignupOrOutError: action.payload,
                courseSignupOrOut: false,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/features/Courses/reducers.js